<template>
  <div>
    <ValidationObserver ref="observer">
      <div>
        <v-container class="pt-5 px-5 pb-6">
          <template>
            <!-- EDU -->
            <div style="font-weight: 600" class="mb-2">
              <span style="color: red">*</span>ระดับการศึกษา / Education
            </div>
            <div
              v-for="(edu, k) in sortedEdu"
              :key="edu.faculty + '__' + k"
              class="pa-2 mb-3 greyboxshadow"
            >
              <div style="text-align: right; height: 14px">
                <v-icon
                  class="mr-2"
                  @click="editEdu(edu, k)"
                  style="color: rgb(10, 81, 136); font-size: 15px"
                  >edit</v-icon
                >
                <v-icon
                  v-if="k == 0"
                  @click="deleteEdu(k)"
                  style="color: #c90000; font-size: 15px"
                  >delete</v-icon
                >
              </div>
              <div style="font-size: 19px; font-weight: 600">
                {{ edu.degree ? edu.degree : "-" }}
              </div>
              <template v-if="edu.university && edu.GPAX">
                <div style="font-size: 18px; padding-bottom: 4px">
                  {{ edu.university ? edu.university : "-" }}
                </div>
                <div style="font-size: 16px; color: darkgrey">
                  {{ edu.faculty ? edu.faculty : "-" }}
                </div>
                <div style="font-size: 16px; color: grey">
                  {{ edu.GPAX ? "GPA " + edu.GPAX : "-" }}
                </div>
              </template>
              <template v-else>
                <div style="margin: 15px">
                  <v-btn
                    @click="editEdu(edu, k)"
                    block
                    outlined
                    :elevation="2"
                    color="primary"
                  >
                    <span style="font-weight: 700; font-size: 18px">
                      กรุณากรอกข้อมูล
                    </span>
                  </v-btn>
                </div>
              </template>
            </div>
            <div class="text-center">
              <v-btn @click="showEdumodal" large icon
                ><v-icon large color="primary">mdi-plus-circle</v-icon></v-btn
              >
            </div>
            <v-dialog v-model="edumodal" persistent>
              <v-card>
                <v-card-text v-if="edumodal" class="py-5">
                  <div class="mb-2">
                    <div class="steplabel">
                      <span style="color: red">*</span>
                      ระดับการศึกษา / Education
                    </div>
                    <div>
                      <ValidationProvider
                        :name="'ระดับการศึกษา'"
                        :rules="'required'"
                        key="ระดับการศึกษา"
                        v-slot="{ errors }"
                      >
                        <v-select
                          :disabled="lockDegree.includes(educations.id)"
                          :error-messages="errors"
                          :hide-details="errors.length ? false : true"
                          v-model="educations.degree"
                          outlined
                          rounded
                          :items="degreesOptions"
                        ></v-select>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="steplabel">
                      <span style="color: red">*</span>
                      ชื่อสถานศึกษา / Institute
                    </div>
                    <div>
                      <ValidationProvider
                        :name="'ชื่อสถานศึกษา'"
                        :rules="'required'"
                        key="ชื่อสถานศึกษา"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          :error-messages="errors"
                          :hide-details="errors.length ? false : true"
                          v-model="educations.university"
                          outlined
                          rounded
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="steplabel">
                      <span style="color: red">*</span>
                      คณะ / Faculty
                    </div>
                    <div>
                      <ValidationProvider
                        :name="'คณะ'"
                        :rules="'required'"
                        key="คณะ"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          :error-messages="errors"
                          :hide-details="errors.length ? false : true"
                          v-model="educations.faculty"
                          outlined
                          rounded
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="mb-2">
                    <div class="steplabel">
                      <span style="color: red">*</span>
                      เกรดเฉลี่ยสะสม / GPAX
                    </div>
                    <div style="width: 50%">
                      <ValidationProvider
                        :name="'เกรดเฉลี่ยสะสม'"
                        :rules="'required'"
                        key="เกรดเฉลี่ยสะสม"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          :hide-details="errors.length ? false : true"
                          :error-messages="errors"
                          v-model="educations.GPAX"
                          outlined
                          rounded
                        ></v-text-field>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="text-center mt-5">
                    <v-btn
                      class="text-capitalize mr-2"
                      outlined
                      rounded
                      large
                      :min-width="128"
                      @click="cancelEdu"
                      color="grey"
                      >Cancel</v-btn
                    >
                    <v-btn
                      @click="addEdu"
                      class="text-capitalize ml-2"
                      dark
                      rounded
                      large
                      color="#0A5188"
                      :min-width="128"
                      >{{ educations.id ? "Save" : "Done" }}</v-btn
                    >
                  </div>
                </v-card-text>
              </v-card>
            </v-dialog>
          </template>
          <!-- <template>
            <div style="font-weight: 600" class="mb-2 mt-6">
              <span style="color: red">*</span>ประสบการณ์การทำงาน / Working
              Experience
            </div>
            <div class="pl-3">
              <v-radio-group @change="onChangeExp" v-model="hasExperience">
                <v-radio color="primary" :value="false">
                  <template v-slot:label>
                    ไม่มีประสบการณ์ทำงาน
                  </template></v-radio
                >
                <v-radio color="primary" :value="true">
                  <template v-slot:label> มีประสบการณ์ทำงาน </template>
                </v-radio>
              </v-radio-group>
            </div>
            <div v-if="hasExperience">
              <div
                v-for="(work, k) in input.work_experiences"
                :key="k"
                class="pa-2 mb-3 greyboxshadow"
              >
                <div style="text-align: right; height: 14px">
                  <v-icon
                    class="mr-2"
                    @click="editWork(work, k)"
                    style="color: rgb(10, 81, 136); font-size: 15px"
                    >edit</v-icon
                  >
                  <v-icon
                    @click="deleteWork(k)"
                    style="color: #c90000; font-size: 15px"
                    >delete</v-icon
                  >
                </div>
                <div style="font-size: 19px; font-weight: 600">
                  {{ work.company }}
                </div>
                <div style="font-size: 18px; padding-bottom: 4px">
                  {{ work.position }}
                </div>
                <div style="font-size: 16px; color: darkgrey">
                  เงินเดือน {{ work.salary }}
                </div>
              </div>
              <div class="text-center">
                <v-btn @click="showWorkexpmodal" large icon
                  ><v-icon large color="primary">mdi-plus-circle</v-icon></v-btn
                >
              </div>
              <v-dialog v-model="workexpmodal" persistent>
                <v-card style="background-color: #f4f3f3">
                  <v-card-text v-if="workexpmodal" class="py-5">
                    <div class="mb-2">
                      <div class="steplabel">
                        <span style="color: red">*</span>
                        ที่ทำงาน / Company
                      </div>
                      <div>
                        <ValidationProvider
                          :name="'ที่ทำงาน'"
                          :rules="'required'"
                          key="ที่ทำงาน"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            :error-messages="errors"
                            :hide-details="errors.length ? false : true"
                            v-model="work_experiences.company"
                            solo
                            dense
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div class="steplabel">
                        <span style="color: red">*</span>
                        ตำแหน่งงาน / Position
                      </div>
                      <div>
                        <ValidationProvider
                          :name="'ตำแหน่งงาน'"
                          :rules="'required'"
                          key="ตำแหน่งงาน"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            :error-messages="errors"
                            :hide-details="errors.length ? false : true"
                            v-model="work_experiences.position"
                            solo
                            dense
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="mb-2">
                      <div class="steplabel">
                        <span style="color: red">*</span>
                        เงินเดือน / Salary
                      </div>
                      <div style="width: 50%">
                        <ValidationProvider
                          :name="'เงินเดือน'"
                          :rules="'required'"
                          key="เงินเดือน"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            :hide-details="errors.length ? false : true"
                            :error-messages="errors"
                            v-model="work_experiences.salary"
                            solo
                            type="number"
                            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                            dense
                          ></v-text-field>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="text-center mt-5">
                      <v-btn
                        style="font-size: 22px"
                        class="text-capitalize mr-2"
                        outlined
                        @click="cancelWork"
                        dense
                        color="grey"
                        rounded
                        >Cancel</v-btn
                      >
                      <v-btn
                        @click="addWork"
                        dense
                        style="font-size: 22px"
                        class="text-capitalize ml-2"
                        outlined
                        rounded
                        color="#0A5188"
                        >{{ editworkKey !== "" ? "Save" : "Done" }}</v-btn
                      >
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </div>
          </template> -->
          <div>
            <UploadSingleFile v-model="input.resume"></UploadSingleFile>
            <div class="caption text-center">
              <p class="ma-0">รองรับไฟล์: .pdf, .jpg, .jpeg, .png</p>
              <p class="ma-0">ขนาดไฟล์ไม่เกิน 5 MB</p>
            </div>
          </div>
        </v-container>
      </div>
      <div class="mt-7 pb-7">
        <v-row dense justify="center">
          <v-col cols="auto">
            <v-btn
              class="text-capitalize"
              outlined
              large
              rounded
              dark
              :loading="saveloading"
              :min-width="128"
              @click="$store.state.step = 2"
              color="grey"
              >Back</v-btn
            >
          </v-col>
          <v-col cols="auto">
            <v-btn
              class="text-capitalize"
              large
              rounded
              :loading="saveloading"
              dark
              :min-width="128"
              @click="next"
              color="#0a5188"
              >Apply</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import UploadSingleFile from "@/components/UploadSingleFile.vue";
import axios from "axios";
export default {
  data() {
    return {
      lockDegree: [],
      uniqueID: 1,
      hasExperience: false,
      saveloading: false,
      edumodal: false,
      editworkKey: "",
      workexpmodal: false,
      input: {
        educations: [],
        work_experiences: [],
        resume: null,
      },
      educations: {
        degree: "",
        university: "",
        faculty: "",
        GPAX: "",
      },
      work_experiences: { company: "", position: "", salary: "" },
      degreesOptions: [
        "มัธยมศึกษาตอนปลาย",
        "ประกาศนียบัตรวิชาชีพ (ปวช.)",
        "ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.)",
        "ปริญญาตรี",
        "ปริญญาโท",
        "ปริญญาเอก",
        "อื่นๆ",
      ],
    };
  },
  components: {
    UploadSingleFile,
  },
  computed: {
    sortedEdu() {
      const sortedBy = {
        อื่นๆ: 6,
        มัธยมศึกษาตอนปลาย: 5,
        "ประกาศนียบัตรวิชาชีพ (ปวช.)": 4,
        "ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.)": 3,
        ปริญญาตรี: 2,
        ปริญญาโท: 1,
        ปริญญาเอก: 0,
      };
      const result = this.input.educations.sort(
        (a, b) => sortedBy[a.degree] - sortedBy[b.degree]
      );
      return result;
    },
  },
  methods: {
    onChangeExp(val) {
      if (!val) {
        this.input.work_experiences = [];
      }
    },
    async next() {
      var vm = this;
      if (
        !this.input.educations.length &&
        !this.input.work_experiences.length &&
        this.hasExperience
      ) {
        await vm.$swal.fire({
          text: "กรุณาเพิ่มระดับการศึกษาและประสบการณ์ทำงาน",
        });
      } else if (!this.input.educations.length) {
        await vm.$swal.fire({
          text: "กรุณาเพิ่มระดับการศึกษา",
        });
      } else if (!this.input.work_experiences.length && this.hasExperience) {
        await vm.$swal.fire({
          text: "กรุณาเพิ่มประสบการณ์ทำงาน",
        });
      } else {
        if (
          this.input.educations.some((el) => {
            return (
              ["ปริญญาตรี", "ปริญญาโท"].includes(el.degree) &&
              (!el.university || !el.GPAX)
            );
          })
        ) {
          await vm.$swal.fire({
            text: "กรุณากรอกข้อมูลให้ครบถ้วน",
          });
        } else {
          this.input.educations.forEach((el, k) => {
            this.input.educations[k] = {
              degree: el.degree,
              university: el.university,
              faculty: el.faculty,
              GPAX: el.GPAX,
            };
          });
          Object.assign(vm.$store.state.profileinfo, vm.input);
          await vm.saveData();
        }
      }
    },
    async saveData() {
      var vm = this;
      return new Promise((resolve) => {
        vm.saveloading = true;
        var data = {
          pageid: vm.query.pageid,
          userid: vm.profile.userId + "__" + vm.query.pageid,
          ...vm.$store.state.profileinfo,
        };
        axios
          .post("https://api-enterprise.zwiz.app/bangkokbankapplicant", data, {
            headers: {
              AUTHORIZATION: "Bearer xxx xxx",
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              // vm.$liff.closeWindow();
              vm.query.view = "StepFinal";
              resolve();
            } else if (response.data.responsecode == 400) {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              resolve();
            }
          });
      });
    },
    deleteEdu(k) {
      this.input.educations.splice(k, 1);
    },
    deleteWork(k) {
      this.input.work_experiences.splice(k, 1);
    },
    getuniqueID() {
      this.uniqueID++;
      return this.uniqueID;
    },

    async addEdu() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        if (this.educations.id) {
          var editIndex = this.input.educations.findIndex(
            (el) => el.id == this.educations.id
          );
          this.input.educations[editIndex] = this.educations;
        } else {
          this.input.educations.push({
            ...this.educations,
            id: this.getuniqueID(),
          });
        }
        var hasMaster = this.input.educations.some(
          (el) => el.degree == "ปริญญาโท"
        );
        var hasBachelor = this.input.educations.some(
          (el) => el.degree == "ปริญญาตรี"
        );
        if (this.educations.degree == "ปริญญาเอก") {
          if (!hasMaster) {
            var id = this.getuniqueID();
            this.input.educations.push({
              degree: "ปริญญาโท",
              university: "",
              faculty: "",
              GPAX: "",
              id,
            });
            this.lockDegree.push(id);
          }
          if (!hasBachelor) {
            var id = this.getuniqueID();
            this.input.educations.push({
              degree: "ปริญญาตรี",
              university: "",
              faculty: "",
              GPAX: "",
              id,
            });
            this.lockDegree.push(id);
          }
        } else if (this.educations.degree == "ปริญญาโท") {
          if (!hasBachelor) {
            var id = this.getuniqueID();
            this.input.educations.push({
              degree: "ปริญญาตรี",
              university: "",
              faculty: "",
              GPAX: "",
              id,
            });
            this.lockDegree.push(id);
          }
        }
        this.cancelEdu();
      }
    },
    async addWork() {
      var isValid = await this.$refs.observer.validate();
      if (isValid) {
        if (this.editworkKey !== "") {
          this.input.work_experiences[this.editworkKey] = this.work_experiences;
        } else {
          this.input.work_experiences.push(this.work_experiences);
        }

        this.cancelWork();
      }
    },
    cancelEdu() {
      this.edumodal = false;
      this.educations = {
        degree: "",
        university: "",
        faculty: "",
        GPAX: "",
      };
    },
    cancelWork() {
      this.workexpmodal = false;
      this.editworkKey = "";
      this.work_experiences = {
        company: "",
        position: "",
        salary: "",
      };
    },
    showEdumodal() {
      this.edumodal = true;
    },
    showWorkexpmodal() {
      this.workexpmodal = true;
    },
    editEdu(edu) {
      this.educations = { ...edu };
      this.edumodal = true;
    },
    editWork(work, k) {
      this.work_experiences = { ...work };
      this.editworkKey = k;
      this.workexpmodal = true;
    },
  },
};
</script>

<style lang="scss">
.greyboxshadow {
  line-height: 21px;
  background-color: #ececec;
  border-radius: 9px;
}
</style>
